var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue } from 'nuxt-property-decorator';
import { serialize } from 'object-to-formdata';
import { ValidationObserver } from 'vee-validate';
let AppForm = class AppForm extends Vue {
    constructor() {
        super(...arguments);
        this.error = {
            message: ''
        };
        this.isLoading = false;
    }
    beforeSubmit() {
        this.resetValidation();
        this.$emit('before-submit', this.formData);
    }
    onSubmit() {
        this.$refs.observer.validate()
            .then((isValid) => {
            if (!isValid) {
                this.scrollToFirstError();
                return;
            }
            if (this.isLoading || this.isParentLoading) {
                return;
            }
            this.isLoading = true;
            this.beforeSubmit();
            this.$axios.post(this.formAction, serialize(this.formData, { booleansAsIntegers: true }), {
                headers: this.formHeaders
            })
                .then((response) => {
                this.$emit('success', response, this.formData);
            })
                .catch((error) => {
                this.handleError(error);
                this.$emit('error', error, this.formData);
            })
                .then(() => {
                this.isLoading = false;
            });
        });
    }
    handleError(error) {
        const response = error.response;
        if (response && response.data) {
            const data = response.data;
            if (data.message) {
                this.error.message = data.message;
            }
            if (data.errors) {
                this.$refs.observer.setErrors(data.errors);
                this.scrollToFirstError();
            }
        }
    }
    resetValidation() {
        this.error = {
            message: ''
        };
    }
    scrollToFirstError() {
        const observer = this.$refs.observer;
        for (const key of Object.keys(observer.fields)) {
            if (observer.fields[key].invalid) {
                this.$scrollTo(observer.refs[key].$el);
                return;
            }
        }
    }
};
__decorate([
    Prop({ type: [String], required: true })
], AppForm.prototype, "formAction", void 0);
__decorate([
    Prop({ type: [Object], required: true })
], AppForm.prototype, "formData", void 0);
__decorate([
    Prop({ type: [Object] })
], AppForm.prototype, "formHeaders", void 0);
__decorate([
    Prop([String])
], AppForm.prototype, "buttonLabel", void 0);
__decorate([
    Prop([String])
], AppForm.prototype, "buttonIcon", void 0);
__decorate([
    Prop()
], AppForm.prototype, "colProps", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], AppForm.prototype, "isParentLoading", void 0);
__decorate([
    Prop([Boolean])
], AppForm.prototype, "showRequiredNote", void 0);
AppForm = __decorate([
    Component({
        components: {
            ValidationObserver
        }
    })
], AppForm);
export default AppForm;
